import { API } from "aws-amplify";
import { getInputContext } from "../utils/api-utils";
import { CASE_MANAGEMENT_SERVICE_API } from "../constants/api-paths";
import { STRYFE_USE_CASE_NAME} from "src/components/StryfeAPI/Constants";

export async function getCaseByCaseId(caseId) {
  let stryfeRequest = {
    useCaseName: STRYFE_USE_CASE_NAME,
    caseId: caseId
  }
  let result = {
    data: {},
    status: ""
  };
  const inputContext = await getInputContext();
  inputContext.body.requestType = "GetCaseByCaseId";
  inputContext.body.requestString = JSON.stringify(stryfeRequest);
  console.log("RequestContext", inputContext);
  const resp = await API.post(
    CASE_MANAGEMENT_SERVICE_API,
    "/getCaseByCaseId",
    inputContext
  );
  if (resp.statusCode === "200") {
    const parsedjson = JSON.parse(resp.body);
    result.data = parsedjson.attributes;
    result.status = parsedjson.status;
    return result;
  } else {
    console.log("No status code" + JSON.stringify(resp));
    throw 'exception occurred';
  }
}
